<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

    export let data: Record<string, any>

    if (!data.options) data.options = ['Opção 1', 'Opção 2']
    if (data.allowOther === undefined) data.allowOther = false
    // Modelos salvos antes desse campo existir não têm otherLabel — cai no rótulo padrão.
    if (data.otherLabel === undefined) data.otherLabel = 'Outro'

    function addOption() {
        data.options = [...data.options, `Opção ${data.options.length + 1}`]
    }

    function removeOption(index: number) {
        data.options = data.options.filter((_: string, i: number) => i !== index)
    }
</script>

<div class="block-preview">
    {#each data.options as option, index (index)}
        <div class="option-row">
            <span class="radio-dot" />
            <input type="text" class="option-input" bind:value={data.options[index]} />
            {#if data.options.length > 1}
                <button type="button" class="option-remove" on:click={() => removeOption(index)}>
                    <Fa icon={faXmark} size="xs" />
                </button>
            {/if}
        </div>
    {/each}
    <button type="button" class="add-option" on:click={addOption}>
        <Fa icon={faPlus} size="xs" />
        <span>Adicionar opção</span>
    </button>

    <div class="other-toggle">
        <label class="other-toggle-check">
            <input type="checkbox" bind:checked={data.allowOther} />
            <span>Exibir campo</span>
        </label>
        <input
            type="text"
            class="other-label-input"
            bind:value={data.otherLabel}
            disabled={!data.allowOther}
            placeholder="Outro"
            title="Rótulo exibido ao lado do campo livre"
        />
    </div>
</div>

<style>
    .block-preview {
        max-width: 420px;
    }
    .option-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 6px;
    }
    .radio-dot {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #adb5bd;
        flex-shrink: 0;
    }
    .option-input {
        flex: 1;
        border: none;
        border-bottom: 1px solid transparent;
        background: transparent;
        font-size: 0.9rem;
        padding: 2px 0;
    }
    .option-input:focus {
        outline: none;
        border-bottom-color: var(--cs2-accent, #4263eb);
    }
    .option-remove {
        border: none;
        background: transparent;
        color: #adb5bd;
        cursor: pointer;
        padding: 2px;
    }
    .option-remove:hover {
        color: #fa5252;
    }
    .add-option {
        display: flex;
        align-items: center;
        gap: 6px;
        border: none;
        background: transparent;
        color: #868e96;
        font-size: 0.85rem;
        padding: 4px 0;
        cursor: pointer;
    }
    .add-option:hover {
        color: var(--cs2-accent, #4263eb);
    }
    .other-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #f1f3f5;
        font-size: 0.8rem;
        color: #495057;
    }
    .other-toggle-check {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        flex-shrink: 0;
    }
    .other-toggle-check input {
        width: 14px;
        height: 14px;
        accent-color: var(--cs2-accent, #4263eb);
    }
    .other-label-input {
        flex: 1;
        min-width: 0;
        border: none;
        border-bottom: 1px solid #dee2e6;
        background: transparent;
        font-size: 0.8rem;
        padding: 2px 0;
        color: inherit;
    }
    .other-label-input:focus {
        outline: none;
        border-bottom-color: var(--cs2-accent, #4263eb);
    }
    .other-label-input:disabled {
        /* anula o !important do css_global.css (input:disabled), que pinta o fundo de escuro */
        background: transparent !important;
        border-color: transparent !important;
        color: #adb5bd !important;
    }
</style>
